import React from 'react';

export function SectionHeader({ icon: Icon, title, subtitle, action, color = '#E63946' }) {
  return (
    <div className="px-6 py-4 border-b border-[hsl(var(--border))] bg-gradient-to-r from-[#09090B]/80 via-[#0a0a0c]/60 to-transparent relative overflow-hidden">
      <div className="absolute inset-0 opacity-20" style={{ background: `linear-gradient(135deg, ${color}15, transparent 50%)` }} />
      <div className="relative flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="w-11 h-11 rounded-xl flex items-center justify-center shadow-lg"
            style={{ 
              background: `linear-gradient(135deg, ${color}, ${color}90)`,
              boxShadow: `0 4px 15px -3px ${color}50`
            }}>
            <Icon size={22} className="text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-white tracking-tight">{title}</h3>
            <p className="text-xs text-[#9CA3AF]">{subtitle}</p>
          </div>
        </div>
        {action}
      </div>
    </div>
  );
}
